'use client'

import type {ComponentProps} from 'react'
import Link from 'next/link'
import {useTranslations} from 'next-intl'
import {createSegmentedTabs} from '@fitro/customer-ui/SegmentedTabs'

export type {SegmentedTabItem} from '@fitro/customer-ui/SegmentedTabs'

const RoutedSegmentedTabs = createSegmentedTabs(Link)

type SegmentedTabsProps = Omit<ComponentProps<typeof RoutedSegmentedTabs>, 'scrollLeftLabel' | 'scrollRightLabel'>

export function SegmentedTabs(props: SegmentedTabsProps) {
    const t = useTranslations('common.actions')

    return <RoutedSegmentedTabs {...props} scrollLeftLabel={t('previous')} scrollRightLabel={t('next')}/>
}
